export const ATJS_STATE = 'ATJS_STATE';
export const DOCUMENT_MODE = 'documentMode';

export const CLOUDINARY_ENDPOINT = 'https://res.cloudinary.com/originenergy/image/upload';

export const TRACKING_PREFIX = 'PROD-';

export const COMPARE_PLANS_PATH =
  '/electricity-gas/plans.html?planfuel=elec_gas&plansearchpostcode=';
